import { SortDirection } from '@amzn/stencil-react-components/table'

import { ModuleType, QueryParams } from 'src/models/dto/ModuleDTO'
import { ModuleStatus } from 'src/models/dto/ModuleStatus'
import {
    ModuleListSortCriteria,
    ModuleSortField,
    PaginationConfig,
} from 'src/models/ListModulesRequest'
import { ModuleSearchQuery } from 'src/pages/search/SearchResultsPage'
import { SearchService } from 'src/services/backend/SearchService'

export const DEFAULT_PAGE_SIZE = 10

export const getSortCriteriaFromParams = (urlSearchParams: URLSearchParams) => {
    const sortField = urlSearchParams.get(QueryParams.SORT_FIELD) ?? 'modifiedAt'
    const sortDirection =
        urlSearchParams.get(QueryParams.SORT_DIRECTION) === SortDirection.Ascending.toString()
            ? SortDirection.Ascending
            : SortDirection.Descending
    return { sortField, sortDirection }
}

export const fromParams = (searchParams: URLSearchParams): ModuleSearchQuery => {
    const sortCriteriaFromParams = getSortCriteriaFromParams(searchParams)
    return {
        search: searchParams.get(QueryParams.SEARCH) ?? '',
        owner: searchParams.get(QueryParams.OWNER) ?? '',
        startDate: searchParams.get(QueryParams.START_DATE) ?? '',
        endDate: searchParams.get(QueryParams.END_DATE) ?? '',
        lastModifiedBy: searchParams.get(QueryParams.LAST_MODIFIED_BY) ?? '',
        searchArchived: searchParams.get(QueryParams.ARCHIVED) === 'true',
        moduleStatus: (searchParams.getAll(QueryParams.STATUS) as ModuleStatus[]) ?? [],
        moduleTypes: (searchParams.getAll(QueryParams.TYPE) as ModuleType[]) ?? [],
        itemOffset: +(searchParams.get(QueryParams.OFFSET) ?? 0),
        numberOfItemsPerPage: +(
            searchParams.get(QueryParams.RECORDS_PER_PAGE) ?? DEFAULT_PAGE_SIZE
        ),
        sortField: sortCriteriaFromParams.sortField as ModuleSortField,
        sortDirection: sortCriteriaFromParams.sortDirection,
    }
}

export const getDefaultModuleSearchQuery = (
    lockedModuleStatus: ModuleStatus[] | undefined,
    lockedModuleTypes: ModuleType[] | undefined
): ModuleSearchQuery => ({
    search: '',
    owner: '',
    startDate: '',
    endDate: '',
    lastModifiedBy: '',
    searchArchived: false,
    moduleStatus: lockedModuleStatus ?? [],
    moduleTypes: lockedModuleTypes ?? [],
    itemOffset: 0,
    numberOfItemsPerPage: DEFAULT_PAGE_SIZE,
    sortField: 'modifiedAt',
    sortDirection: SortDirection.Descending,
})

export const toSearchParams = (newQuery: ModuleSearchQuery, urlQueryParams = true) => {
    const { itemOffset, numberOfItemsPerPage, sortField, sortDirection, ...filters } = newQuery
    const pageConfig: PaginationConfig = {
        offset: itemOffset,
        numberOfRecordsPerPage: numberOfItemsPerPage,
    }
    const sortCriteria: ModuleListSortCriteria = { sortField, sortDirection }
    return SearchService.constructQueryParams(
        newQuery.search,
        newQuery.searchArchived,
        filters,
        pageConfig,
        sortCriteria,
        urlQueryParams
    )
}
